module.exports = "<div class=\"spinner\"><i class=\"fas fa-spinner fa-spin\"></i></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/spinner/spinner.component.html
// module id = ./src/app/shared/spinner/spinner.component.html
// module chunks = main